import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import { AuthUserContext } from '../Session';
import * as ROUTES from '../../constants/routes';
import '../PaymentSuccess/styles.css';

const PaymentFailureBase = ({ firebase }) => {
  const { agreementId } = useParams();
  const history = useHistory();
  const authUser = useContext(AuthUserContext);
  const [loading, setLoading] = useState(true);
  const [agreementData, setAgreementData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!authUser || !agreementId) {
      setLoading(false);
      return;
    }

    // Fetch agreement details from Firestore
    const unsubscribe = firebase.db
      .collection('franchiseAgreements')
      .doc(agreementId)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            
            // Verify agreement belongs to current user
            if (data.userId !== authUser.uid && authUser.email !== 'jeethbuildcon@gmail.com') {
              setError('Unauthorized access');
              setLoading(false);
              return;
            }

            setAgreementData(data);
            setLoading(false);
          } else {
            setError('Agreement not found');
            setLoading(false);
          }
        },
        (err) => {
          console.error('Error loading agreement data:', err);
          setError('Failed to load agreement information');
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, [authUser, agreementId, firebase]);

  const handleRetryPayment = () => {
    history.push(`/franchise-agreement/${agreementId}`);
  };

  const handleGoToDashboard = () => {
    history.push(ROUTES.DASHBOARD);
  };

  if (loading) {
    return (
      <div className="payment-status-container">
        <div className="payment-status-loading">
          <div className="spinner"></div>
          <p>Loading payment information...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-status-container">
        <div className="payment-status-card error">
          <div className="status-icon">❌</div>
          <h1>Error</h1>
          <p>{error}</p>
          <button onClick={handleGoToDashboard} className="btn-primary">
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-status-container">
      <div className="payment-status-card failure">
        <div className="status-icon-large">⚠️</div>
        <h1>Payment Unsuccessful</h1>
        <p className="failure-message">
          Your payment could not be processed at this time.
          {agreementData?.paymentFailureReason && (
            <><br/><strong>Reason:</strong> {agreementData.paymentFailureReason}</>
          )}
        </p>

        <div className="retry-info">
          <h3>Why did this happen?</h3>
          <ul>
            <li>• Payment may have been declined by your bank</li>
            <li>• Insufficient funds in your account</li>
            <li>• Network connectivity issues</li>
            <li>• Payment was cancelled</li>
            <li>• Incorrect payment details entered</li>
          </ul>
        </div>

        <div className="next-steps">
          <h3>What should you do next?</h3>
          <ul>
            <li>✓ Check your bank account balance</li>
            <li>✓ Verify your card is activated for online payments</li>
            <li>✓ Try a different payment method</li>
            <li>✓ Contact your bank if the issue persists</li>
            <li>✓ Retry the payment when ready</li>
          </ul>
        </div>

        {agreementData && !agreementData.paymentCompleted && (
          <div style={{
            background: '#f8f9fa',
            borderRadius: '12px',
            padding: '1.5rem',
            margin: '2rem 0',
            textAlign: 'left'
          }}>
            <p style={{ color: '#495057', fontSize: '1rem', margin: 0 }}>
              <strong>Note:</strong> Your franchise application is still active. 
              You can retry the payment anytime before it expires.
            </p>
          </div>
        )}

        <div className="action-buttons">
          <button onClick={handleRetryPayment} className="btn-primary">
            Retry Payment
          </button>
          <button onClick={handleGoToDashboard} className="btn-secondary">
            Go to Dashboard
          </button>
        </div>

        <p style={{ 
          marginTop: '2rem', 
          color: '#6c757d', 
          fontSize: '0.875rem',
          textAlign: 'center'
        }}>
          Need help? Contact us at: support@douglasandmccartney.com
        </p>
      </div>
    </div>
  );
};

export default withFirebase(PaymentFailureBase);

